var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.prefecture && _vm.locality)?_c('span',{staticClass:"text-normal"},[_vm._v(_vm._s(_vm.prefecture)+"・"+_vm._s(_vm.locality))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }